import React, { Component } from 'react';
import { noop, get, isNil } from 'lodash';
import PropTypes from 'prop-types';

const withFocusedState = (WrappedComponent) => {
    class WithFocusedState extends Component {
        static propTypes = {
            ...(WrappedComponent.propTypes || {}),
            onFocus: PropTypes.func,
            onBlur: PropTypes.func,
        };

        static defaultProps = {
            ...(WrappedComponent.defaultProps || {}),
            onFocus: noop,
            onBlur: noop,
        };

        state = {
            focused: false,
        };

        componentDidMount() {
            if (this.props.autoFocus) {
                this.updateFocused(true);
            }
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.disabled && this.state.focused) {
                this.updateFocused(false);
            }
        }

        updateFocused = (value) => this.setState({ focused: value });

        onFocus = (event) => {
            const { disabled, onFocus, autoFocus } = this.props;

            if (disabled) return;
            if (autoFocus && !isNil(get(event, 'target.value'))) {
                const { target } = event;
                const value = target.value.toString();

                target.selectionStart = value.length;
                target.selectionEnd = value.length;
            }
            this.updateFocused(true);
            onFocus && onFocus(event);
        };

        onBlur = (event) => {
            const { disabled, onBlur } = this.props;

            if (disabled) return;
            this.updateFocused(false);
            onBlur && onBlur(event);
        };

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    focused={this.state.focused}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                />
            );
        }
    }

    return WithFocusedState;
};

export default withFocusedState;
